export const mutations = {
  setProgram: (state, payload) => {
    state.program = payload;
  },
  setWorkoutSchedules(state, schedules) {
    state.workoutSchedules = schedules;
  }
};
